import React, { useContext, useState, useCallback } from "react";
import { FlatList, Dimensions, StyleSheet, View, Share, Image, TouchableHighlight, Text, Platform } from "react-native";
import { useFocusEffect, useNavigation  } from '@react-navigation/native';

import ActivityIndicator from "../components/ActivityIndicator";
import colors from "../config/colors";
import routes from "../navigation/routes";
import connectionConfig from "../config/settings";
import configurationPost from "../config/configurationPost";
//import useAuth from "../auth/useAuth";
import dateNow from "../utility/dateNow";
import createNotification from "../utility/createNotification";
import { Audio } from "expo-av";
import CardFeed from "../components/CardFeed";
import { ListItemAccount, ListItemSeparator } from "../components/lists";
import Icon from "../components/Icon";
import Screen from "../components/Screen";
import HistoryScreen from "./HistoryScreen";
//import CardHistory from "../components/CardHistory";
import CardFeedMenu from "../components/CardFeedMenu";
import AuthContext from "../auth/context";
import storage from "../auth/storage";

var pointer = 0
var blockSize = 15
var pageNumber = 0
var arraySeeds = []
var v 

function FeedScreen({ route }) {
    //debugger
    useFocusEffect(
        useCallback(() => {
            //debugger 
            pageNumber = 0
            arraySeeds = []
            pointer = 0
            getFeed()
            initialMenu()
            console.log('FeedScreen -> useFocusEffect...........', JSON.parse(user).alias)
        }, [])
    );
    const navigation = useNavigation()
    const [menuItems, setMenuItems] = useState([])
    const [loading, setLoading] = useState(false)
    const [historyViseble, setHistoryViseble] = useState(false)
    const [menuFeed, setMenuFeed] = useState([])

    const [listing, setListing] = useState([])// llena la lista de semillas
    const { user, setUser } = useContext(AuthContext);  
    var perfilUri = ''
    var webUrl = ''
    var seedVideoUri = ''
    //console.log('FeedScreen ->', connectionConfig.switchS3)
    if (connectionConfig.switchS3 === true) {
        //console.log('FeedScreen -> guarda las imagenes en un bucket de aws S3')
        perfilUri = connectionConfig.imageUrlS3
        webUrl = connectionConfig.imageUrlS3
        seedVideoUri = connectionConfig.imageUrlS3
        //debugger
    } else {
        console.log('else switchS3')
        perfilUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
        webUrl = connectionConfig.imageUrl + '/seedImages/'
        seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'
    }

const initialMenu = () => {
   // alert('notUser')
    if(JSON.parse(user).alias === 'notUser' ){
      //  alert('notUser')
        setMenuFeed([
           {
               typeButton: "search",
              id:'1'
              
           },
           {
               typeButton: "notUser",
               id:'2'
           },
            {
               typeButton: "quienSomos",
              id:'3'
              
           },

        //    {
        //        typeButton: "chat",
        //        id:'3'
              
        //    },
        //    {
        //        typeButton: "history",
        //        id:'4'
        //    },
       ])
      }else{
       setMenuFeed([
                   {
                       typeButton: "search",
                      id:'1'
                      
                   },
                   {
                       typeButton: "profile",
                       id:'2'
                   },
                //    {
                //        typeButton: "chat",
                //        id:'3'
                      
                //    },
                   {
                       typeButton: "history",
                       id:'4'
                   },
               ])
      }
}

    const onShare = async () => {
      try {
        const result = await Share.share({
          message:
            'React Native | A framework for building native apps using React',
        });
        if (result.action === Share.sharedAction) {
          if (result.activityType) {
            // shared with activity type of result.activityType
          } else {
            // shared
          }
        } else if (result.action === Share.dismissedAction) {
          // dismissed
        }
      } catch (error) {
        alert(error.message);
      }
    };

    //debugger
   
    const menuFilter = [
        {
            title: "Por título",
            icon: {
                name: "search",
                iconFamily: "MaterialIcons",
                backgroundColor: colors.pistache,
                color: colors.green
            },

            targetScreen: routes.SEARCH_SEED,
        },
        {
            title: "Por descripción",
            icon: {
                name: "search",
                iconFamily: "MaterialIcons",
                backgroundColor: colors.fuente,
            },
            targetScreen: routes.SEARCH_SEED,
        },
                {
            title: "Por usuario",
            icon: {
                name: "search",
                iconFamily: "MaterialIcons",
                backgroundColor: colors.fuente,
            },
            targetScreen: routes.SEARCH_USER,
        },
    ];

    const date = dateNow();
    var indexLike = 0
    var numLikes = 0
    const WIDTH = (Dimensions.get('window').width) / 2;
    const HEIGHT = 419.7       //419.95  //4.19698  //419.6994076923077 //315.2727355957031
    //(Dimensions.get('window').height) * .5;

    const sizeItemLayout = (listing, index) => (
        { length: HEIGHT, offset: HEIGHT * index, index }
    );

    const getFeed = async () => {
        //  debugger
        pointer = pageNumber * blockSize
        setLoading(true)
        var post_values = {
            //userId : userId
            pointer: pointer,
            blockSize: blockSize
        }
        //establece parámetros de configurción del post
        configurationPost.body = JSON.stringify(post_values)
        //solicita el servicio para adquirir los pubicaciones del servidor
        await fetch(connectionConfig.apiUrl + '/SelectFeed/', configurationPost)
            .then(response => response.json())
            .then(response => {
                if (response.data.length === 0) {
                    if (pageNumber > 0) {
                        setLoading(false)
                    } else {
                        setLoading(false)
                    }
                } else {
                    pageNumber++
                    if (arraySeeds.length > 0) {
                        arraySeeds = [...arraySeeds, ...response.data]
                    } else {
                        arraySeeds = response.data
                    }
                    setListing(arraySeeds)
                    setLoading(false)
                }
            })
            .catch(err => {
                console.log('getSeeds failed :( review internet service -> /SelectFeed/', err)
            })
    }

    //-----------------------------------------------------------------------------------------------------------------------
    // 1. Servicio que valida si ya existe el like del usuario en la publicación (función inicio del encadenamiento de servicios) 
    //-----------------------------------------------------------------------------------------------------------------------
    const onPressValidationLikeUser = async () => {
        try {
            const { sound } = await Audio.Sound.createAsync(
                require('../assets/sounds/ringtones-heart.mp3')   // Ejecuta un sonido al hacer like  
            )
            await sound.playAsync()
        } catch (error) {
            console.log(':(', err)
        }
        validationLikeNotification()
        //debugger
        var post_values = {
            seedId: listing[indexLike].seedId,
            userId: JSON.parse(user).userId
        }
        configurationPost.body = JSON.stringify(post_values)
        await fetch(connectionConfig.apiUrl + '/SelectValidateSeedsLikes/', configurationPost)
            .then(response => response.json())
            .then(response => {
                if (response.data.length != 0) {
                    deleteLikePublication()
                } else {
                    insertLike()
                }
            })
            .catch(err => {
                console.log(':( review internet service /SelectValidateSeedsLikes/', err)
            })
    }
    //------------------------------------
    //1.1 Valida si ya existe la noitificación
    //------------------------------------
    const validationLikeNotification = async () => {
        //debugger
        var notificationTypeId = 3
        var seedId = listing[indexLike].seedId
        var userId = JSON.parse(user).userId
        console.log('entre al select validador -> ', seedId, userId)
        var post_values = {
            seedId: seedId,
            userId: userId,
            notificationTypeId: notificationTypeId
        }
        configurationPost.body = JSON.stringify(post_values)
        await fetch(connectionConfig.apiUrl + '/SelectValidateNotification/', configurationPost)
            .then(response => response.json())
            .then(response => {
                var descripNotification = JSON.parse(user).userName + ' le dio like a tu semilla'
                if (response.data.length != 0) {
                    createNotification.deleteLikeNofication(seedId, userId, notificationTypeId)
                } else {
                    createNotification.insertNotification(descripNotification, seedId, userId, notificationTypeId)
                }
            })
            .catch(err => {
                console.log(':( review internet service /SelectValidateNotificationLike/', err)
            })
    }
    //--------------------------------------------------------
    // 2. servicio que borra el like si ya existe en la publicación
    //---------------------------------------------------------
    const deleteLikePublication = async () => {
        var post_values = {
            seedId: listing[indexLike].seedId,
            userId: JSON.parse(user).userId
        }
        configurationPost.body = JSON.stringify(post_values)
        await fetch(connectionConfig.apiUrl + '/deleteLikeSeeds/', configurationPost)
            .then(response => response.json())
            .then(response => {
                countOfLikes()
            })
            .catch(err => {
                console.log(':( review internet service /deleteLikeSeeds/', err)
            })
    }

    //-------------------------
    // 2.1. Agrega un nuevo like 
    //-------------------------
    const insertLike = async () => {
        // debugger
        var post_values = {
            seedId: listing[indexLike].seedId,
            userId: JSON.parse(user).userId,
            dateLikeSeed: date,
            likeType: 1
        }
        configurationPost.body = JSON.stringify(post_values)
        await fetch(connectionConfig.apiUrl + '/insertSeedLike/', configurationPost)
            .then(response => response.json())
            .then(response => {
                countOfLikes()
            })
            .catch(err => {
                console.log('Insert fixo failed :( review internet service -> insertSeedLike', err)
            })
    }

    //------------------------------------------------------------------
    // 3. Servicio que nos va a traer el count de likes por semilla.
    //------------------------------------------------------------------
    const countOfLikes = async () => {
        var post_values = {
            seedId: listing[indexLike].seedId,
        }
        configurationPost.body = JSON.stringify(post_values)
        await fetch(connectionConfig.apiUrl + '/SelectCountSeedLikes/', configurationPost)
            .then(response => response.json())
            .then(response => {
                numLikes = response.data[0].total_likes
                incrementLikes()

            })
            .catch(err => {
                console.log(':( review internet service => /SelectCountSeedLikes/', err)
            })
    }
    //------------------------------------------------------------------------------
    // 4. servicio que hace un incremeto al campo de número de likes de una semilla
    //------------------------------------------------------------------------------
    const incrementLikes = async () => {
        //debugger    
        var post_values = {
            seedId: listing[indexLike].seedId,
            totalSeedLikes: numLikes
        }
        configurationPost.body = JSON.stringify(post_values)
        await fetch(connectionConfig.apiUrl + '/UpdateIncrementLikeSeeds/', configurationPost)
            .then(response => response.json())
            .then(response => {
                //debugger
                arraySeeds[indexLike].totalSeedLikes = numLikes
                setListing([...arraySeeds])
                setLoading(false)
            })
            .catch(err => {
                console.log('Insert fixo failed :( review internet service /UpdateIncrementLikeSeeds/', err)
            })
    }


    
    return (
        <>
            <ActivityIndicator visible={loading} />
            <Screen style={styles.screen}>
                <View style={styles.profile} >
                    {
                     //...................................................
                     //Sección para el menu de la parte de arriba del Feed
                     //...................................................   
                    }
                    <FlatList
                            data={menuFeed}
                            keyExtractor={(menuItem) => menuItem.id.toString()}
                           horizontal={true}
                            renderItem={({ item, index }) => (
                                <CardFeedMenu
                                //algo={console.log('ejemplo de ->', item.typeButton )}
                                    typeButton={item.typeButton}
                                    onPress={
                                        item.typeButton === 'search' ? 
                                        () => {
                                       // console.log(':)')
                                        if (menuItems.length > 0) {
                                            var arr = []
                                            setMenuItems([...arr])
                                        } else {
                                            setMenuItems(menuFilter)
                                        }
                                        // navigation.navigate(routes.USER_FIXO)
                                         }
                                    : item.typeButton === 'profile' ? 
                                    () => {
                                        navigation.navigate(routes.NO_BOTTON)
                                    }
                                    : item.typeButton === 'chat' ? 
                                    () => {
                                    // var userIdListing = JSON.parse(user).userId
                                    // var ulasAA = JSON.parse(user).userId
                                    // var ulasBB = JSON.parse(user).userId
                                    // var ulasCC = JSON.parse(user).userId

                                    // navigation.navigate(routes.MAP, { userIdListing, ulasAA,ulasBB, ulasCC })
                                   // onShare()
                                    } 
                                    : item.typeButton === 'history' ?
                                    () =>
                                     {
                                        console.log('entre ', routes.USER_FIXO)
                                        var screen = 'FeedScreen'
                                        var userId = JSON.parse(user).userId
                                        navigation.navigate(routes.DETAIL_HITORY, {screen, userId})
                                         }
                                    : item.typeButton === 'notUser' ?
                                         () =>
                                          {
                                              //alert('lalala')
                                           //  console.log('entre ', routes.USER_FIXO)
                                           storage.removeToken() 
                                           setUser('')
                                         }
                                         : item.typeButton === 'quienSomos' ?
                                         () =>
                                          {
                                            console.log('entre ', routes.USER_FIXO)
                                        navigation.navigate('Quienes Somos')

                                         }:
                                    null
                                 }
                               />
                            )}
                        />
                </View>
                {
                  //....................................................
                  //Sección para pintar el menu de busqueda de contenido 
                  //....................................................
                }
                {menuItems.length > 0 ?
                <View style={styles.containerContent}>
                        <FlatList
                            data={menuItems}
                            keyExtractor={(menuItem) => menuItem.title}
                            ItemSeparatorComponent={ListItemSeparator}
                            //style={styles.listaSearch}
                            renderItem={({ item, index }) => (
                                <ListItemAccount
                                    titleRol={item.title}
                                    IconComponent={
                                        <Icon
                                            size={40}
                                            iconFamily={item.icon.iconFamily}
                                            name={item.icon.name}
                                            iconColor={item.icon.color}
                                            backgroundColor={item.icon.backgroundColor}
                                        />
                                    }
                                    onPress={() => {
                                        var typeSerch = menuItems[index].title
                                        navigation.navigate(item.targetScreen, typeSerch)
                                    }
                                    }
                                />
                            )}
                        />
                        </View>
                        :
                        null
                    }
                    {
                        historyViseble === true ?
                         <HistoryScreen navigation={navigation} userId = { JSON.parse(user).userId} />
                        :
                        null 
                    }
                 {
                  //.............................................
                  //Seccion para pintar el contenido del Feed
                  //.............................................
                 }
                <FlatList
                    // getItemLayout={sizeItemLayout}
                    data={listing}
                    keyExtractor={(listing) => listing.seedId.toString()}
                    //initialScrollIndex={route.params.index}
                    onEndReachedThreshold={.5}
                    onEndReached={() => getFeed()}
                    renderItem={({ item, index }) => (
                        // <View onLayout= {object => 
                        //         itemHeights[index] = object.nativeEvent.layout.height}>
                        // <>                      
                        // <CardFeed
                        //     title={item.seedName}
                        //     subTitle={item.totalSeedLikes} // 
                        //     seedDescription={item.seedDescription}
                        //     userPhoto={perfilUri + item.userId + '_' + item.userPhoto}
                        //     userName={item.userName}
                        //     type={item.type}
                        //     onPressNumLikes={() => {
                        //         indexLike = index
                        //         var seedId = listing[indexLike].seedId
                        //         navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, { seedId })
                        //         //console.log("presNumLique", indexLike)
                        //     }
                        //     }
                        //     imageUrl={
                        //         item.seedPhoto.includes('.mp4') ?
                        //             seedVideoUri + item.seedPhoto :
                        //             item.seedPhoto.includes('.mov') ?
                        //                 seedVideoUri + item.seedPhoto :
                        //                 webUrl + item.seedPhoto}

                        //     onPress={() => {
                        //         var seedId = listing[index].seedId
                        //         var screen = 'ListingsSeedsScreen'//{screen: 'ListingsSeedsScreen'}
                        //         navigation.navigate(routes.SEED_DETAILS, { item, seedId, screen, screen })
                        //     }
                        //     }

                        //     onPressLike={() => {
                        //         indexLike = index
                        //         onPressValidationLikeUser()
                        //     }
                        //     }
                        //     commentsNum={item.totalSeedComments}
                        //     actionsNum={item.totalActions}
                        //     onPressComment={() => {
                        //         indexLike = index
                        //         var seedId = listing[indexLike].seedId
                        //         navigation.navigate(routes.COMMENTS_SEEDS, { item, seedId })
                        //     }
                        //     }
                        //    // thumbnailUrl={webUrl + item.userId + '_' + item.seedPhoto}
                        //  thumbnailUrl={webUrl + item.seedPhoto}
                        // //  onPressShare={()=>{
                        // //     var seedId = listing[index].seedId
                        // //     var seedUrl = 'http://18.116.234.21:19006/AppNavigator/Feed/Seed%20Details?item=%5Bobject%20Object%5D&seedId='
                        // //     //var seedUrl = 'http://localhost:19006/AppNavigator/Feed/Seed%20Details?item=%5Bobject%20Object%5D&seedId='
                        // //     + seedId+'&screen=ListingsSeedsScreen'
                        // //     //alert(seedUrl)
                        // //     onShare(seedUrl)
                        // //     console.log('seedUrl ->', seedUrl )
                        // // }}
                        // />
                        // </>
                        //  </View>


                       //-----------------------------
                        <>
                            <CardFeed
                                title={item.seedName}
                                subTitle={item.totalSeedLikes} // 
                                seedDescription={item.seedDescription}
                                // userPhoto1={console.log(item.userPhoto.substring(25,29))}
                                userPhoto={item.seedPhoto === null ?
                                    perfilUri :
                                    item.userPhoto.substring(25, 29) === '.jpg' ?
                                        perfilUri + item.userId + '_' + item.userPhoto.substring(0, 19) + '_userfit.jpg' :
                                        perfilUri + item.userId + '_' + item.userPhoto.substring(0, 19) + '_userfit.png'
                                }
                                //propExample={console.log("PropExample: ",perfilUri )}
                                alias={item.alias}
                                userDescription={item.userDescription}
                                userPhotoFoundUser={item.userPhoto}
                                userName={item.userName}
                                type={item.type}
                                onPressNumLikes={() => {
                                    indexLike = index
                                    var seedId = listing[indexLike].seedId
                                    navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, { seedId })
                                    //console.log("presNumLique", indexLike)
                                }
                                }
                                imageUrl={
                                    // item.seedPhoto.includes('.mp4') ?
                                    //     seedVideoUri + item.seedPhoto :
                                    //     item.seedPhoto.includes('.mov') ?
                                    //         seedVideoUri + item.seedPhoto :
                                    //         webUrl + item.seedPhoto}
                                    item.seedPhoto === undefined ?
                                    seedVideoUri + "Poner Foto" :
                                    item.seedPhoto === null ?
                                        seedVideoUri + "Poner Foto" :
                                        item.seedPhoto.includes('.mp4') ?
                                            seedVideoUri + item.seedPhoto :
                                            item.seedPhoto.includes('.mov') ?
                                                seedVideoUri + item.seedPhoto :
                                                item.seedPhoto.substring(37, 41) === 'jpg' ?
                                                    webUrl + item.seedPhoto + '_seedfit.jpg' :
                                                    item.seedPhoto.substring(37, 41) === 'png' ?
                                                        webUrl + item.seedPhoto + '_seedfit.png' :
                                                        webUrl + item.seedPhoto
                                                    }

                                onPress={() => {
                                    var userIdOfFeedItem = listing[index].userId
                                    console.log("userIdOfFeedItem en FeedScreen ", userIdOfFeedItem)
                                    var foundUserChecker = 'off'
                                    if (userIdOfFeedItem === userId) {
                                        foundUserChecker = 'off'
                                    } else {
                                        foundUserChecker = 'foundUserChecker'
                                    }
                                    console.log("foundUserChecker en FeedScreen ", foundUserChecker)
                                    var screen = 'FeedScreen'   // 'ListingsSeedsScreen'
                                    navigation.navigate(routes.SEED_DETAILS, { item, screen, foundUserChecker })
                                }
                                }
                                onPressForOrigin={() => {

                                   var orgin = item.origin
                                    console.log('org', orgin, '  ////   ', item)
                                    getSeedforOrigin(orgin, index)
                                }
                                }
                                onPressLike={() => {
                                    indexLike = index
                                    onPressValidationLikeUser()
                                }
                                }
                                commentsNum={item.totalSeedComments}
                                actionsNum={item.totalActions}
                                onPressComment={() => {
                                    indexLike = index
                                    var seedId = listing[indexLike].seedId
                                    navigation.navigate(routes.COMMENTS_SEEDS, { item, seedId })
                                }
                                }
                                thumbnailUrl={webUrl + item.userId + '_' + item.seedPhoto}
                                onPressShare={() => {
                                    var seedId = listing[index].seedId
                                    var seedUrl = 'http://18.222.152.71:19006/AppNavigator/Feed/Seed%20Details?item=%5Bobject%20Object%5D&seedId='
                                        //var seedUrl = 'http://18.116.234.21:19006/AppNavigator/Feed/Seed%20Details?item=%5Bobject%20Object%5D&seedId='
                                        //var seedUrl = 'http://localhost:19006/AppNavigator/Feed/Seed%20Details?item=%5Bobject%20Object%5D&seedId='
                                        + seedId + '&screen=ListingsSeedsScreen'
                                    // alert(seedUrl)
                                    onShare(seedUrl)
                                    // console.log('Listing ->', listing )
                                }}
                                userId={item.userId}
                                statusLike={item.myLike === null ? false : true}
                                createDateSeed={item.createDateSeed}
                                onPressFolloresSeed={() => {
                                    console.log('hola seessdasdasd')
                                    indexLike = index
                                    var seedId = listing[indexLike].seedId
                                    navigation.navigate(routes.FOLLOWERS_SEEDS, { item, seedId })
                                }
                                }
                                followersSeed={item.totalSeedFollowers}
                                seedNameOrigin={item.seedNameOrigin}
                                //seedDescriptionOrigin={item.seedDescriptionOrigin}
                                seedPhotoOrigin={
                                    item.seedPhotoOrigin === undefined ?
                                    seedVideoUri + "Poner Foto" :
                                    item.seedPhotoOrigin === null ?
                                        seedVideoUri + "Poner Foto" :
                                        item.seedPhotoOrigin.includes('.mp4') ?
                                            seedVideoUri + item.seedPhotoOrigin :
                                            item.seedPhotoOrigin.includes('.mov') ?
                                                seedVideoUri + item.seedPhotoOrigin :
                                                item.seedPhotoOrigin.endsWith('.jpg')  ?
                                                    webUrl + item.seedPhotoOrigin + '_seedfit.jpg' :
                                                    item.seedPhotoOrigin.endsWith('.png') ?
                                                        webUrl + item.seedPhotoOrigin + '_seedfit.png' :
                                                        webUrl + item.seedPhotoOrigin + '_seedfit.jpeg' 

                                }
                                seedId={item.seedId}
                                seedTotalActionsOrigin={item.seedTotalActionsOrigin}  
                                seedTotalSeedLikesOrigin={item.seedTotalSeedLikesOrigin}  
                                seedTotalSeedFollowersOrigin={item.seedTotalSeedFollowersOrigin}  
                                typeOrigin={item.typeOrigin} 
                                origin={item.origin}
                                youtubeId={item.youtubeId} 
                                originOfOrigin ={item.originOfOrigin}
                                //.....para CardRequrements
                                qty={item.qty}
                                mesure={item.mesure}
                                unitaryPrice={item.unitaryPrice}
                                currency={item.currency}
                                sub={item.sub}
                                note={item.note}
                            />
                        </>

                    )}
                />
            </Screen>

        </>
    );
}

const styles = StyleSheet.create({
    screen: {
        padding: 1,
        backgroundColor: colors.fondoImagenes,
    },
    profile: {
        flexDirection: "row",
    },
    iconSeedSearch: {
        marginTop: '2.5%',
        marginLeft: '84%',
        position: 'absolute'
    },
    image: {
        // marginLeft: '-53%',
        // marginRight: '-39%',
        marginTop: "5%",
        marginBottom: '3%',
        width: 45,
        height: 45,
        borderRadius: 35,
        //position: 'absolute'
    },
    image2: {
        marginLeft: '43.5%',
        marginTop: "2%",
        marginBottom: '3%',
        width: 45,
        height: 45,
        borderRadius: 35,
        //position:'absolute'
    },
    textSearch: {
        marginTop: "13%",
        marginRight: '3%',
        marginLeft: '52%',
        fontSize: 12

    },
    textChat: {
        marginLeft: '-10%',
        marginTop: "13%",
    },
    textSearch2: {
        marginTop: "13%",
        marginRight: '3%',
        marginLeft: '28%',
        fontSize: 15
    },
    textProfile: {
        marginLeft: '3%',
        marginRight: '-25%',
        marginTop: "13%",
        marginBottom: '1%',
        fontSize: 14
    },
    textProfile2: {
        marginLeft: '-30%',
        marginTop: "13%",
       // marginRight:'5%',
        marginBottom: '1%',
        fontSize: 14
    },
    containerContent: {
      marginTop: 15,

       height: 150
        //position:'absolute'
    },
    iconRocket: {
        marginLeft: '5%',
        marginTop: "4%",
    },
    position: {
        // position: 'absolute'
        marginTop: "2%",
        marginRight: '-13%',
        marginLeft: '13%',
    }
});

export default FeedScreen;
